"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NavFlyoutBanner;
const react_1 = __importDefault(require("react"));
const ImageBanner_1 = __importDefault(require("./ImageBanner/ImageBanner"));
const PremiumImageBanner_1 = __importDefault(require("./PremiumImageBanner/PremiumImageBanner"));
const DuplexBanner_1 = __importDefault(require("./DuplexBanner/DuplexBanner"));
const PremiumDuplexBanner_1 = __importDefault(require("./PremiumDuplexBanner/PremiumDuplexBanner"));
function NavFlyoutBanner(props) {
    if (props.designType === "Image") {
        return react_1.default.createElement(ImageBanner_1.default, Object.assign({}, props));
    }
    if (props.designType === "PremiumImage") {
        return (react_1.default.createElement(PremiumImageBanner_1.default, Object.assign({}, props)));
    }
    if (props.designType === "Duplex") {
        return react_1.default.createElement(DuplexBanner_1.default, Object.assign({}, props));
    }
    if (props.designType === "PremiumDuplex") {
        return (react_1.default.createElement(PremiumDuplexBanner_1.default, Object.assign({}, props)));
    }
    // Fallback to null if designType is not recognized
    return null;
}
